// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2364748b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styles — Startup Village Platform */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: var(--text-main);
  background: var(--bg-body);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  background-color: var(--surface);
  color: var(--text-main);
  border-color: var(--border);
}

.btn:hover:not(:disabled) {
  background-color: var(--bg-body);
  border-color: var(--border-focus);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

.btn-primary {
  background: var(--primary);
  color: #ffffff;
}

.btn-primary:hover:not(:disabled) {
  background: var(--primary-hover);
  filter: brightness(0.92);
}

.btn-secondary {
  background: var(--surface);
  color: var(--text-main);
  border: 1px solid var(--border);
}

.btn-secondary:hover:not(:disabled) {
  background: var(--bg-body);
  border-color: var(--border);
}

.btn-danger {
  background: #EF4444;
  color: #fff;
}

.btn-danger:hover:not(:disabled) {
  background: #B91C1C;
  border-color: #B91C1C;
}

.btn-sm {
  padding: 6px 12px;
  font-size: 0.8125rem;
}

.btn-icon {
  padding: 6px;
  border-radius: 6px;
  color: var(--text-muted);
}

.btn-icon:hover:not(:disabled) {
  color: var(--text-main);
  background-color: var(--bg-body);
}

.btn-danger.btn-icon {
  background-color: transparent;
  color: #EF4444;
  border-color: #FEE2E2;
  box-shadow: none;
}

.btn-danger.btn-icon:hover:not(:disabled) {
  background-color: #FEE2E2;
  color: #B91C1C;
  border-color: #FECACA;
}

/* Forms */
.form-group {
  margin-bottom: 1.25rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: var(--text-muted);
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 8.5px 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 0.875rem;
  color: var(--text-main);
  background: var(--surface);
  transition: all 150ms ease;
}

.form-group select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 40px;
}

.form-group input:hover,
.form-group select:hover,
.form-group textarea:hover {
  border-color: var(--border-focus);
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: var(--primary);
  border-width: 2px;
  padding: 7.5px 13px; /* Compensate for thicker border */
  outline: none;
}

.form-row {
  display: flex;
  gap: 1rem;
}

.form-row .form-group {
  flex: 1 1;
}

.field-error {
  display: block;
  color: #EF4444;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

/* Banners */
.error-banner {
  background: #FEE2E2;
  color: #EF4444;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.25rem;
  font-size: 0.875rem;
}

.success-banner {
  background: #D1FAE5;
  color: #10B981;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.25rem;
  font-size: 0.875rem;
}

/* Data tables */
.data-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--surface);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.data-table thead {
  background: #F9FAFB;
}

.data-table th {
  text-align: left;
  padding: 10px 16px;
  font-size: 0.6875rem;
  font-weight: 600;
  color: var(--text-light);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-bottom: 1px solid var(--border);
}

.data-table td {
  padding: 0 16px;
  height: 48px;
  font-size: 0.875rem;
  border-bottom: 1px solid var(--border);
  color: var(--text-main);
}

.data-table tbody tr {
  transition: background-color 150ms ease;
}

.data-table tbody tr:hover {
  background-color: var(--bg-body);
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.actions-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.4rem;
  height: 100%;
}

.no-data {
  text-align: center;
  color: var(--text-light);
  padding: 2rem;
}

/* Badges */
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  height: 24px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 500;
}

.badge-published { background: #D1FAE5; color: #059669; }
.badge-draft { background: #F3F4F6; color: #4B5563; }
.badge-cancelled { background: #FEE2E2; color: #B91C1C; }
.badge-admin { background: #EDE9FE; color: #6D28D9; }
.badge-staff { background: #DBEAFE; color: #1D4ED8; }
.badge-security { background: #FEF3C7; color: #B45309; }
.badge-entreprise { background: #CCFBF1; color: #0F766E; }

/* Checkbox */
.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  -webkit-user-select: none;
          user-select: none;
}

/* Mobile Responsiveness */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 1rem;
}

.table-responsive table {
  width: 100%;
  min-width: 800px; /* Force minimum width to prevent squishing on mobile */
}

.header-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .header-actions {
    flex-direction: column;
    align-items: stretch;
  }
  
  .header-actions > * {
    width: 100%;
  }
  
  .header-actions input, 
  .header-actions button {
    width: 100%;
  }
}

/* Mobile Card Tables */
@media (max-width: 768px) {
  /* Remove the forced min-width for table-responsive since we're breaking it down to cards */
  .table-responsive table {
    min-width: auto;
  }
  
  .data-table thead {
    display: none;
  }
  
  .data-table {
    background: transparent;
    border: none;
    box-shadow: none;
  }
  
  .data-table, 
  .data-table tbody, 
  .data-table tr, 
  .data-table td {
    display: block;
    width: 100%;
  }
  
  .data-table tr {
    margin-bottom: 1rem;
    border: 1px solid var(--border);
    border-radius: 8px;
    padding: 0.5rem 1rem;
    background: var(--surface);
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    cursor: pointer;
    position: relative;
    transition: all 0.2s;
  }
  
  .data-table tr::after {
    content: '▼';
    position: absolute;
    right: 1rem;
    top: 1.25rem;
    font-size: 0.75rem;
    color: var(--text-muted);
    transition: transform 0.2s;
  }
  
  .data-table tr.expanded::after {
    content: '▲';
  }
  
  /* Hide all td except the first one when not expanded */
  .data-table tr:not(.expanded) td:not(:first-child) {
    display: none;
  }

  /* Make sure the first td doesn't overlap the chevron when collapsed */
  .data-table tr:not(.expanded) td:first-child {
    border-bottom: none;
  }
  
  .data-table td {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    text-align: right;
    padding: 0.75rem 2rem 0.75rem 0; /* 2rem right padding to avoid chevron */
    border-bottom: 1px solid var(--border);
    position: relative;
    border-left: none;
  }
  
  .data-table td:last-child {
    border-bottom: 0;
  }
  
  .data-table td::before {
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 45%;
    padding-right: 10px;
    text-align: left;
    font-weight: 600;
    color: var(--text-muted);
    font-size: 0.85rem;
  }
}

.checkbox-label input[type="checkbox"] {
  width: auto;
  margin-top: 0.25rem;
}

/* Responsive */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0FAA0F;EAC1F,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;EACzC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAAwR;EACxR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB,EAAE,kCAAkC;EACvD,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,uDAAuD;AAC3E;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;EACE,2FAA2F;EAC3F;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;;IAIE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,oBAAoB;IACpB,0BAA0B;IAC1B,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA,uDAAuD;EACvD;IACE,aAAa;EACf;;EAEA,sEAAsE;EACtE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B,EAAE,wCAAwC;IACzE,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,MAAM;EACR;AACF","sourcesContent":["/* Global styles — Startup Village Platform */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: var(--text-main);\n  background: var(--bg-body);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 150ms ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  background-color: var(--surface);\n  color: var(--text-main);\n  border-color: var(--border);\n}\n\n.btn:hover:not(:disabled) {\n  background-color: var(--bg-body);\n  border-color: var(--border-focus);\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.btn-primary {\n  background: var(--primary);\n  color: #ffffff;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--primary-hover);\n  filter: brightness(0.92);\n}\n\n.btn-secondary {\n  background: var(--surface);\n  color: var(--text-main);\n  border: 1px solid var(--border);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--bg-body);\n  border-color: var(--border);\n}\n\n.btn-danger {\n  background: #EF4444;\n  color: #fff;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #B91C1C;\n  border-color: #B91C1C;\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 0.8125rem;\n}\n\n.btn-icon {\n  padding: 6px;\n  border-radius: 6px;\n  color: var(--text-muted);\n}\n\n.btn-icon:hover:not(:disabled) {\n  color: var(--text-main);\n  background-color: var(--bg-body);\n}\n\n.btn-danger.btn-icon {\n  background-color: transparent;\n  color: #EF4444;\n  border-color: #FEE2E2;\n  box-shadow: none;\n}\n\n.btn-danger.btn-icon:hover:not(:disabled) {\n  background-color: #FEE2E2;\n  color: #B91C1C;\n  border-color: #FECACA;\n}\n\n/* Forms */\n.form-group {\n  margin-bottom: 1.25rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 8.5px 14px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: var(--text-main);\n  background: var(--surface);\n  transition: all 150ms ease;\n}\n\n.form-group select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\n.form-group input:hover,\n.form-group select:hover,\n.form-group textarea:hover {\n  border-color: var(--border-focus);\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  border-color: var(--primary);\n  border-width: 2px;\n  padding: 7.5px 13px; /* Compensate for thicker border */\n  outline: none;\n}\n\n.form-row {\n  display: flex;\n  gap: 1rem;\n}\n\n.form-row .form-group {\n  flex: 1;\n}\n\n.field-error {\n  display: block;\n  color: #EF4444;\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n/* Banners */\n.error-banner {\n  background: #FEE2E2;\n  color: #EF4444;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1.25rem;\n  font-size: 0.875rem;\n}\n\n.success-banner {\n  background: #D1FAE5;\n  color: #10B981;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1.25rem;\n  font-size: 0.875rem;\n}\n\n/* Data tables */\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--surface);\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.data-table thead {\n  background: #F9FAFB;\n}\n\n.data-table th {\n  text-align: left;\n  padding: 10px 16px;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: var(--text-light);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  border-bottom: 1px solid var(--border);\n}\n\n.data-table td {\n  padding: 0 16px;\n  height: 48px;\n  font-size: 0.875rem;\n  border-bottom: 1px solid var(--border);\n  color: var(--text-main);\n}\n\n.data-table tbody tr {\n  transition: background-color 150ms ease;\n}\n\n.data-table tbody tr:hover {\n  background-color: var(--bg-body);\n}\n\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.actions-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.4rem;\n  height: 100%;\n}\n\n.no-data {\n  text-align: center;\n  color: var(--text-light);\n  padding: 2rem;\n}\n\n/* Badges */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 12px;\n  height: 24px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.badge-published { background: #D1FAE5; color: #059669; }\n.badge-draft { background: #F3F4F6; color: #4B5563; }\n.badge-cancelled { background: #FEE2E2; color: #B91C1C; }\n.badge-admin { background: #EDE9FE; color: #6D28D9; }\n.badge-staff { background: #DBEAFE; color: #1D4ED8; }\n.badge-security { background: #FEF3C7; color: #B45309; }\n.badge-entreprise { background: #CCFBF1; color: #0F766E; }\n\n/* Checkbox */\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  user-select: none;\n}\n\n/* Mobile Responsiveness */\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  margin-bottom: 1rem;\n}\n\n.table-responsive table {\n  width: 100%;\n  min-width: 800px; /* Force minimum width to prevent squishing on mobile */\n}\n\n.header-actions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 768px) {\n  .header-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .header-actions > * {\n    width: 100%;\n  }\n  \n  .header-actions input, \n  .header-actions button {\n    width: 100%;\n  }\n}\n\n/* Mobile Card Tables */\n@media (max-width: 768px) {\n  /* Remove the forced min-width for table-responsive since we're breaking it down to cards */\n  .table-responsive table {\n    min-width: auto;\n  }\n  \n  .data-table thead {\n    display: none;\n  }\n  \n  .data-table {\n    background: transparent;\n    border: none;\n    box-shadow: none;\n  }\n  \n  .data-table, \n  .data-table tbody, \n  .data-table tr, \n  .data-table td {\n    display: block;\n    width: 100%;\n  }\n  \n  .data-table tr {\n    margin-bottom: 1rem;\n    border: 1px solid var(--border);\n    border-radius: 8px;\n    padding: 0.5rem 1rem;\n    background: var(--surface);\n    box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n    cursor: pointer;\n    position: relative;\n    transition: all 0.2s;\n  }\n  \n  .data-table tr::after {\n    content: '▼';\n    position: absolute;\n    right: 1rem;\n    top: 1.25rem;\n    font-size: 0.75rem;\n    color: var(--text-muted);\n    transition: transform 0.2s;\n  }\n  \n  .data-table tr.expanded::after {\n    content: '▲';\n  }\n  \n  /* Hide all td except the first one when not expanded */\n  .data-table tr:not(.expanded) td:not(:first-child) {\n    display: none;\n  }\n\n  /* Make sure the first td doesn't overlap the chevron when collapsed */\n  .data-table tr:not(.expanded) td:first-child {\n    border-bottom: none;\n  }\n  \n  .data-table td {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    text-align: right;\n    padding: 0.75rem 2rem 0.75rem 0; /* 2rem right padding to avoid chevron */\n    border-bottom: 1px solid var(--border);\n    position: relative;\n    border-left: none;\n  }\n  \n  .data-table td:last-child {\n    border-bottom: 0;\n  }\n  \n  .data-table td::before {\n    content: attr(data-label);\n    position: absolute;\n    left: 0;\n    width: 45%;\n    padding-right: 10px;\n    text-align: left;\n    font-weight: 600;\n    color: var(--text-muted);\n    font-size: 0.85rem;\n  }\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: auto;\n  margin-top: 0.25rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
